<button
  type="button"
  class="tw-inline-flex tw-shrink-0 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0"
  [ngxTippy]="popoverTemplate"
  [tippyProps]="tippyProps"
>
  <ng-content></ng-content>
</button>

<ng-template #popoverTemplate>
  <div class="tw-flex tw-w-[318px] tw-flex-col tw-gap-4 tw-p-3 tw-font-inter" role="dialog">
    <div class="tw-flex tw-w-full tw-flex-col tw-gap-3">
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
        <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
          <img [src]="headerIconSrc()" alt="" class="tw-h-3.5 tw-w-3.5 tw-shrink-0" width="14" height="14" />
          <p class="tw-m-0 tw-whitespace-nowrap tw-text-sm tw-font-semibold tw-leading-normal tw-text-white tw-font-inter">
            {{ headerTitle() }}
          </p>
        </div>
        @if (showTotalCost()) {
          <p class="tw-m-0 tw-shrink-0 tw-whitespace-nowrap tw-text-xs tw-font-semibold tw-leading-normal tw-text-gray-100">
            {{ totalCostLabel() }}
          </p>
        }
      </div>

      <app-invitation-channel-history-body
        [channel]="channel()"
        [entries]="activeHistory()?.entries ?? []"
        [isLoading]="activeHistory()?.isLoading ?? false"
        [isLoadingMore]="activeHistory()?.isLoadingMore ?? false"
        [hasMore]="activeHistory()?.hasMore ?? false"
        variant="dark"
        maxHeightClass="tw-max-h-[250px]"
        (loadMore)="loadMoreHistory.emit()"
      />
    </div>

    @if (showSendCta()) {
      <button
        type="button"
        class="tw-flex tw-h-[34px] tw-w-full tw-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-overflow-hidden tw-rounded-md tw-border-0 tw-bg-blue-600 tw-px-3 tw-py-2 hover:tw-bg-blue-700"
        [disabled]="isSending()"
        (click)="onSendInvitation()"
      >
        <img
          src="assets/images/v2/invitation-channel-popover/send-invitation.svg"
          alt=""
          class="tw-h-3 tw-w-3 tw-shrink-0"
          width="12"
          height="12"
        />
        <span class="tw-whitespace-nowrap tw-text-xs tw-font-medium tw-leading-normal tw-text-white">{{ sendCtaLabel() }}</span>
      </button>
    } @else if (blockedSendReason()) {
      <div
        class="tw-flex tw-w-full tw-shrink-0 tw-items-start tw-gap-2 tw-rounded-lg tw-border tw-p-3"
        [ngClass]="blockedSendBannerClass()"
        role="status"
      >
        <img
          [src]="blockedSendIconSrc()"
          alt=""
          class="tw-mt-0.5 tw-h-5 tw-w-5 tw-shrink-0"
          width="20"
          height="20"
        />
        <p class="tw-m-0 tw-text-xs tw-font-medium tw-leading-normal tw-text-gray-100 tw-font-inter">{{ blockedSendMessage() }}</p>
      </div>
    }
  </div>
</ng-template>
